import {Observable} from 'rxjs';
import {CreateAgreementPayloadDto} from '@features/agreement/application/use_cases/create-agreement/dto/create-agreement.payload.dto';
import {CreateAgreementResponseDto} from '@features/agreement/application/use_cases/create-agreement/dto/create-agreement.response.dto';
import {ListAgreementPayloadDto} from '@features/agreement/application/use_cases/list-agreement/dto/list-agreement.payload.dto';
import {ListAgreementResponseDto} from '@features/agreement/application/use_cases/list-agreement/dto/list-agreement.response.dto';

export const AGREEMENT_PORT = Symbol("AGREEMENT_PORT");

export abstract class AgreementPort {
  abstract createAgreement(payload: CreateAgreementPayloadDto): Observable<CreateAgreementResponseDto>;
  abstract listAgreement(payload: ListAgreementPayloadDto): Observable<ListAgreementResponseDto>;
}
